import { render, staticRenderFns } from "./Plafonds.vue?vue&type=template&id=701133c2&"
import script from "./Plafonds.vue?vue&type=script&lang=js&"
export * from "./Plafonds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports